<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2026-->

<div class="modal-header">
  <h3 class="modal-title">Integrated Insights</h3>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" *ngIf="insights.length > 0">
  <p class="text-muted m-b-md">
    Personalized synthesis across your MBTI, strengths, gifts/values, passions,
    and identity statements.
  </p>
  <ul class="list-unstyled">
    <li *ngFor="let insight of insights" class="m-b-md">
      <strong class="text-primary-2">{{ insight.title }}:</strong>&nbsp;{{ insight.body }}
    </li>
  </ul>
</div>

<div class="modal-body text-center" *ngIf="insights.length === 0">
  <i class="fa fa-magic fa-2x text-muted m-b-sm"></i>
  <h5 class="text-muted">Personalized insights are still generating</h5>
  <p class="text-muted">
    This section is composed from your IPSAT data + your archetype pattern.
    If you just purchased your report, check back in a moment.
  </p>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="close()">Close</button>
</div>
